import React, { useState, ChangeEvent } from "react";
import { DataGrid } from "@mui/x-data-grid";
import MuiPagination from "@mui/material/Pagination";
import LinearProgress from "@mui/material/LinearProgress";
import useTranslation from "../hooks/traslation";

type props = {
  columns: any;
  rows: any;
  count?: any;
  page?: any;
  onPageChange?: any;
  loading?: any;
};

export default function TableComponent({
  rows,
  columns,
  count,
  page,
  onPageChange,
  loading,
}: props) {
  const [searchValue, setSearchValue] = useState("");

  const handleSearch = (value: string) => {
    setSearchValue(value);
  };
  const Pagination = ({ page, onPageChange }: any) => {
    let totalPages = Math.ceil(count / 10);

    return (
      <MuiPagination
        color="primary"
        count={totalPages}
        page={page}
        disabled={rows?.length === 0}
        onChange={(event, newPage) => {
          onPageChange(event, newPage - 1);
        }}
      />
    );
  };

  return (
    <DataGrid
      getRowId={(row) => row.id ?? row._id}
      slots={{
        pagination: () => (
          <Pagination onPageChange={onPageChange} page={page} />
        ),
        // loadingOverlay: (props) => (
        //   <LinearProgress style={{ height: 4 }} {...props} />
        // ),
      }}
      localeText={{
        noRowsLabel: "No data found",
      }}
      loading={loading}
      rows={rows}
      columns={columns}
      disableRowSelectionOnClick
      disableColumnMenu
      disableColumnFilter
      slotProps={{
        toolbar: {
          value: searchValue,
          clearSearch: () => handleSearch(""),
          onChange: (event: ChangeEvent<HTMLInputElement>) =>
            handleSearch(event.target.value),
        },
      }}
      sx={{
        ".MuiDataGrid-iconButtonContainer": {
          width: "auto",
          visibility: "visible",
        },
        ".MuiDataGrid-sortIcon": {
          opacity: "inherit !important",
        },
      }}
      rowHeight={70}
    />
  );
}
